import { useEffect, useMemo, useState } from 'react'

import { DROPBOX_APP_KEY } from '@/config'
import { createDropboxSource } from './dropboxSource'
import { loadDropins } from './dropins'

// Loads dropins.js when the add-files screen mounts. Loading it on click gets the chooser popup blocked.
const useDropinsLoaded = (appKey: string | undefined) => {
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
    if (!appKey) return
    loadDropins(appKey).then(setIsLoaded)
  }, [appKey])
  return isLoaded
}

export const useDropboxSource = () => {
  const isLoaded = useDropinsLoaded(DROPBOX_APP_KEY)
  return useMemo(() => {
    const source = createDropboxSource(DROPBOX_APP_KEY)
    return isLoaded && source.isAvailable() ? source : null
  }, [isLoaded])
}
